<template>
  <div class="footer flex-center mt-2">
    <button class="btn btn-primary btn-round"
            :type="type"
            @click="$emit('click')">
      <slot></slot>
    </button>
  </div>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: 'button'
            },
        }
    }
</script>

<style scoped>
</style>
